import Vue from '../../lib/utils/vue3compat/vue.js?vue3';
// eslint-disable-next-line no-restricted-imports
import Vuex from '../../lib/utils/vue3compat/vuex.js?vue3';
import actions from './actions.js?vue3';
import mutations from './mutations';
import createState from './state';

Vue.use(Vuex);

export default () =>
  new Vuex.Store({
    actions,
    mutations,
    state: createState(),
  });
